import { useFetch, postFetch } from "./utils.js";

const API_URL = import.meta.env.VITE_API_ENDPOINT + "api/"; //'http://localhost:3000/api/';

/**
 * EVENT ENDPOINTS
 */

export const verifyToken = async (rfApiProfileId, exhibitorId) => {
  let { data, error } = await useFetch(
    API_URL + "rainfocus/verifytoken/" + rfApiProfileId + "/" + encodeURIComponent(exhibitorId),
  );
  return data;
};

export const fetchLocalDataDump = async (eventId) => {
  let { data, error } = await useFetch(
    API_URL + "rainfocus/localdatadump/" + eventId,
  );
  return data.data;
};

export const fetchRainfocusDataDump = async (rfApiProfileId) => {
  let { data, error } = await useFetch(
    API_URL + "rainfocus/rfdatadump/" + rfApiProfileId,
  );
  return data;
};

export const sync = async (eventId, rfApiProfileId) => {
  let { data, error } = await useFetch(
    API_URL + "rainfocus/syncEvent/" + eventId + "/" + rfApiProfileId,
  );
  return data;
};

export const reserveBooths = async (
  rfApiProfileId,
  exhibitorId,
  eventId,
  booths,
) => {
  // console.log("RESERVE BOOTHS", rfApiProfileId, exhibitorId, eventId, {
  //   booths,
  // });

  let { data, error } = await postFetch(
    API_URL +
      "rainfocus/reservebooths/" +
      rfApiProfileId +
      "/" +
      exhibitorId +
      "/" +
      eventId,
    { booths },
  );
  return data;
};
